// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Z1C29","head":"Table_head__1nq94","col":"Table_col__3iPAN"};